import React, { Component, useState, useEffect } from "react";
import { withRouter, Redirect } from 'react-router-dom'

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: null
  };

  // 生命周期函数，一旦后台组件报错，就会触发
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error
    };
  }

  componentDidCatch(error, info) {
    console.log(info);
    console.log(error);
    requestAnimationFrame(() => {
      this.props.history.push('/error?type=UI&message=' + error.stack.replace(/\n/g, '<br />'));
    });
  }

  render() {
    if (this.state.error) {
      // 如果发生错误，跳转到错误页面
      return <></>;
    } else {
      return this.props.children;
    }
  }
}

export default withRouter(ErrorBoundary);
